<template>
  <div data-theme="undergraduate">
    <default-header />
     <Submenu/>
    <div class="body">
        <nuxt />
    </div>
    <default-footer />
    <modal />
  </div>
</template>

<script>
import DefaultHeader from '~/components/header-default';
import DefaultFooter from '~/components/footer-default';
import Modal from '~/components/modals/modal';
import Submenu from '~/components/submenu';

export default {
  middleware: 'gtm',
  components: {
    DefaultHeader,
    DefaultFooter,
    Modal,
    Submenu,
  },
  mounted() {
    const { partner_id = '' } = this.$route.query;
    const { dataLayer } = this.$store.state;

    window.QB = { userId: '' }; // Sorry. It's made this way in GTM
    window.dataLayer.push(Object.assign(dataLayer, { partner_id }));

    MathJax.Hub.Config({
      CommonHTML: { linebreaks: { automatic: true } }
    });
  },
}
</script>

<style lang="scss">
  @import '@quero/zilla-core/src/themes/undergraduate/colors.scss';
</style>
